import useSWR from 'swr';
import {useRouteLoaderData} from 'react-router-dom';
import fetcherWithToken from '@/helpers/fetcherWithToken';

const API_ROUTE =
  'https://admin.ethicssocioeconomics.com/api/1.0/assessments/';

function useLogbook({assessmentId}, options = {}) {
  const {userSession} = useRouteLoaderData('root') || {};
  const {data, error, isLoading, mutate, isValidating} = useSWR(
    () =>
      assessmentId && userSession?.accessToken?.jwtToken
        ? [`${API_ROUTE}${assessmentId}/logbook`, userSession?.accessToken?.jwtToken]
        : null,
    ([url, token]) => fetcherWithToken(url, token),
    options
  );

  return {
    logbook: data,
    isLoading,
    isError: error,
    mutate,
    isValidating,
  };
}

export default useLogbook;
